import { customAgGridTheme } from '@unified-ui/utilities';
import { GetRowIdParams, GridOptions } from 'ag-grid-community';
import { OwnerHeaderComponent } from 'libs/shared/components/src/lib/report-list/report-list-owner-header.component';

export const gridOptions: GridOptions = {
    treeData: true,
    treeDataParentIdField: 'parentId',
    groupDisplayType: 'custom',
    components: {
        ownerHeaderComponent: OwnerHeaderComponent
    },
    statusBar: {
        statusPanels: [{ statusPanel: 'agTotalRowCountComponent' }, { statusPanel: 'agFilteredRowCountComponent' }]
    },
    suppressMoveWhenRowDragging: true,
    defaultColDef: {
        sortable: true,
        resizable: true,
        editable: false,
        suppressSizeToFit: false,
        suppressAutoSize: false,
        floatingFilter: false,
        suppressHeaderFilterButton: true,
        suppressHeaderMenuButton: true,
        filter: false,
        suppressColumnsToolPanel: true
    },
    groupDefaultExpanded: 0,
    columnDefs: [{ field: 'id', colId: 'id', headerName: 'Id', hide: true, filter: false, suppressColumnsToolPanel: true }],
    headerHeight: 35,
    rowHeight: 24,
    animateRows: true,
    multiSortKey: 'ctrl',
    copyHeadersToClipboard: true,
    suppressLastEmptyLineOnPaste: true,
    getRowId: (params: GetRowIdParams) => params.data.id,
    theme: customAgGridTheme
};
